import { useState } from 'react';
import * as GivebutterPlusWelcomeDialog from 'assets/js/pages/account-settings/account-about/givebutter-plus/GivebutterPlusWelcomeDialog';
import { SubscriptionFormEdit } from 'assets/js/pages/account-settings/account-about/givebutter-plus/SubscriptionFormEdit';
import { SubscriptionFormNew } from 'assets/js/pages/account-settings/account-about/givebutter-plus/SubscriptionFormNew';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const SubscriptionSettings = () => {
    const { validGivebutterPlusPlan } = useCurrentAccount();
    const [isWelcomeDialogOpen, setIsWelcomeDialogOpen] = useState(false);

    return (
        <>
            <div
                className="px-2 pb-16 pt-4"
                key={`${validGivebutterPlusPlan?.tier.interval}_${validGivebutterPlusPlan?.tier.max_contacts}`}
            >
                {validGivebutterPlusPlan ? (
                    <SubscriptionFormEdit />
                ) : (
                    <SubscriptionFormNew onSuccess={() => setIsWelcomeDialogOpen(true)} />
                )}
            </div>
            <GivebutterPlusWelcomeDialog.Root
                open={isWelcomeDialogOpen}
                onOpenChange={setIsWelcomeDialogOpen}
            />
        </>
    );
};

export { SubscriptionSettings };
